











































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { filterDeburr } from '../../utils/functions';
import { tipoPartoStrings } from '../../utils/constants';

import { Exame } from '../../../../back/src/entity/Exame';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import { StatusExame, TipoParto, ResultadoDeExameFormData } from '../../../../back/src/types';

export default Vue.extend({
  name: 'ResultadosDeExamesFormPedido',
  props: {
    paciente: {
      type: Object as () => Paciente,
      default: {} as Paciente,
    },
    gestacao: {
      type: null || Object as () => Gestacao,
    },
    exames: {
      type: Array as () => Exame[],
    },
    consultaId: {
      type: null || Number,
      default: null,
    },
    hideSuccess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: {
        submit: false,
      },
      searchInput: '',
      form: {
        exameId: null,
        observacoes: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    formResultadoDeExame():
      Vue & { validate: () => boolean, reset: () => void, resetValidation: () => void } {
      return this.$refs.formResultadoDeExame as Vue & {
        validate: () => boolean,
        reset: () => void,
        resetValidation: () => void
      };
    },
    examesItens() {
      const optionsExames = _.map(
        _.orderBy(this.exames as Exame[], ['grupo_exame_id', 'ordem']),
        exame => ({ value: exame.id, text: exame.nome }),
      );
      optionsExames.push({ value: 0, text: 'Outro...' });
      return optionsExames;
    },
    tituloGestacao(): string {
      if (!this.gestacao) {
        return 'Sem gestação associada';
      }
      if (this.paciente.gestacao_atual && this.paciente.gestacao_atual.id === this.gestacao.id) {
        return 'Gestação atual';
      }
      const momentDataParto = moment(this.gestacao.data_parto);
      const dataParto = momentDataParto.isValid() ? momentDataParto.format('DD/MM/YYYY') : '';
      const tipoParto = _.has(tipoPartoStrings, this.gestacao.tipo_parto)
        ? ` - ${tipoPartoStrings[this.gestacao.tipo_parto]}`
        : '';
      let nomeBebes = '';
      if (this.gestacao.tipo_parto === TipoParto.N || this.gestacao.tipo_parto === TipoParto.C) {
        nomeBebes = ` - ${this.gestacao.nome1}${this.gestacao.nome2 ? ` & ${this.gestacao.nome2}` : ''}`;
      }
      return `Gestação anterior (${dataParto}${tipoParto}${nomeBebes})`;
    },
  },
  methods: {
    filterDeburr(item: any, queryText: string, itemText: string) {
      return filterDeburr(queryText, itemText);
    },
    limpaForm() {
      this.searchInput = '';
      this.form.exameId = null;
      this.form.status = null;
      this.form.dataExame = '';
      this.form.observacoes = '';
      this.form.resultado = '';
      this.formResultadoDeExame.resetValidation();
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      if (!this.formResultadoDeExame.validate()) {
        return;
      }
      const formData: ResultadoDeExameFormData = {
        exame_id: (this.form.exameId === 0 ? null : this.form.exameId),
        nome_exame: this.form.nomeExame,
        gestacao_id: this.gestacao ? this.gestacao.id : null,
        paciente_id: this.paciente.id,
        consulta_id: this.consultaId,
        status: StatusExame.S,
        observacoes: this.form.observacoes || null,
        data_exame: null,
        resultado: null,
      };
      this.loading.submit = true;
      try {
        const response = await Requester.resultadoDeExame.criaResultadoExame(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          if (!this.hideSuccess) {
            this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso' });
          }
          this.$emit('novoResultadoDeExame', response.data);
          this.limpaForm();
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
